import { createMemoryHistory, createWebHistory, createRouter } from "vue-router";

import Status from "@/views/StatusView.vue";
import Pilots from "@/views/PilotsView.vue";
import Chassis from "@/views/ChassisView.vue";
import Logs from "@/views/LogsView.vue";
import Lore from "@/views/LoreView.vue";
import Relations from "@/views/RelationsView.vue";
//import Maps from "@/views/MapView.vue";
import Factions from "@/views/FactionsView.vue";
import Timeline from "@/views/TimelineView.vue";
import Terminal from "@/views/TerminalView.vue";
import Config from "@/data/info/general-config.json";

const DEFAULT_TITLE = Config.defaultTitle;
const routes = [
	{
		path: "/",
		redirect: "/status",
	},
	{
		path: "/status",
		name: "Mission Status",
		component: Status,
		props: true,
		meta: { title: `${DEFAULT_TITLE} MISSION STATUS` },
	},
	{
		path: "/logs",
		name: "Logs",
		component: Logs,
		props: true,
		meta: { title: `${DEFAULT_TITLE} MISSION LOG` },
	},
	//{
	//	path: "/map",
	//	name: "Map",
	//	component: Maps,
	//	props: true,
	//	meta: { title: `${DEFAULT_TITLE} REGIONAL MAP` },
	//},
	{
		path: "/pilots",
		name: "Pilots",
		component: Pilots,
		props: true,
		meta: { title: `${DEFAULT_TITLE} KAVALIERS` },
	},
	{
		path: "/chassis",
		name: "Chassis",
		component: Chassis,
		props: true,
		meta: { title: `${DEFAULT_TITLE} CHASSIS` },
	},
	{
		path: "/relations",
		name: "Relations",
		component: Relations,
		props: true,
		meta: { title: `${DEFAULT_TITLE} THE MILIEU` },
	},
	{
		path: "/baronic-record",
		name: "Grand Archive",
		component: Lore,
		props: true,
		meta: { title: `${DEFAULT_TITLE} GRAND ARCHIVE` },
	},
	{
		path: "/factions",
		name: "Factions",
		component: Factions,
		props: true,
		meta: { title: `${DEFAULT_TITLE} BARONIC RECORD` },
	},
	{
		path: "/timeline",
		name: "Timeline",
		component: Timeline,
		props: true,
		meta: { title: `${DEFAULT_TITLE} THE ANNALS` },
	},
	{
		path: "/terminal",
		name: "Terminal",
		component: Terminal,
		meta: { title: `${DEFAULT_TITLE} TERMINAL` },
	},
];

// Dev-only style gallery (npm run dev): import.meta.env.DEV is false in production
// builds, so the route and its view are left out of the live site entirely.
if (import.meta.env.DEV) {
	routes.push({
		path: "/styleguide",
		name: "Style Guide",
		component: () => import("@/views/StyleGuideView.vue"),
		props: true,
		meta: { title: `${DEFAULT_TITLE} STYLE GUIDE` },
	});
}

const router = createRouter({
	history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				el: to.hash,
				behavior: "smooth",
			};
		}
	},
});

router.beforeEach((to, from, next) => {
	// Use next tick to handle router history correctly
	// see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
	document.title = `${to.meta.title}`;
	next();
});

export default router;
